export default "__VITE_ASSET__980d30ca__"